export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getLandmarkList: function getLandmarkList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/landmark/get",
        method: "get",
        params: data
      });
    },
    addLandmark: function addLandmark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/landmark/add",
        method: "post",
        data: data
      });
    },
    updateLandmark: function updateLandmark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/landmark/update",
        method: "post",
        data: data
      });
    },
    deleteLandmark: function deleteLandmark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/landmark/delete",
        method: "post",
        data: data
      });
    }
  };
});